import { Box, HStack, StackProps, Icon, IconProps } from "@chakra-ui/react";
import SwapIcon from "components/SwapIcon";
import TraitsCanvas, { TraitsCanvasProps } from "components/TraitsCanvas";
import useApplyTraitChanges from "hooks/useApplyTraitsChanges";

type BeforeAfterPreviewProps = {
  currentTraits: number[];
  changedTraits: number[];
  arrowSize?: IconProps["w"];
  spacing?: StackProps["spacing"];
} & Omit<TraitsCanvasProps, "traits">;

const BeforeAfterPreview = ({
  currentTraits,
  changedTraits,
  arrowSize = "4",
  ...rest
}: BeforeAfterPreviewProps) => {
  const afterTraits = useApplyTraitChanges(currentTraits, changedTraits);

  return (
    <Box position="relative">
      <HStack spacing="2px">
        <TraitsCanvas traits={currentTraits} {...rest} />
        <TraitsCanvas traits={afterTraits} {...rest} />
      </HStack>

      <Icon
        as={SwapIcon}
        w="14"
        color="secondary.500"
        position="absolute"
        left="50%"
        top="-4"
        transform="translate(-50%, -50%)"
        zIndex={1}
      />
    </Box>
  );
};

export default BeforeAfterPreview;
